import React from "react";
import PageHeader from "../common/ui/pageheader";

export default function Sectionheading({ onAddClick }) {
  return (
    <PageHeader
      // Main title displayed on the page header
      title="Add Section"
      // Subtitle or description for the page
      subtitle="Here you can record arriving sections."
      // Text for the action button
      buttonText="Add Section"
      // Event handler called when the button is clicked
      onButtonClick={onAddClick}
    />
  );
}
